import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAccount } from '@/lib/account';

/**
 * Routes that need a session.
 *
 * The check is against the stored token, not against `/api/user/me` — waiting for that
 * request would flash the sign-in page on every reload for a user who is perfectly
 * signed in. A token that turns out to be dead is handled where it actually fails: the
 * api client clears the session on a 401 it cannot refresh, and this then redirects.
 *
 * The attempted path rides along in `state` so signing in returns the user to what
 * they clicked rather than to the dashboard.
 */
export function RequireAuth() {
  const account = useAccount();
  const location = useLocation();

  if (!account) {
    return <Navigate to="/sign-in" replace state={{ from: location.pathname + location.search }} />;
  }
  return <Outlet />;
}
